<template>
  <div>
    <LHeaderMain>
      <LNav />
    </LHeaderMain>
    <div class="back">
      <section class="container-fluid about-hotel" id="about-hotel">
        <div class="row">
          <div class="container top">
            <div class="row">
              <h3 class="heading_style">{{ t("main.h.mainDescription") }}</h3>
              <p class="description_style">{{ t("main.texts.theBeast") }}</p>
            </div>
          </div>
          <div class="col-12 main">
            <div class="row">
              <div class="col-lg-6 text">
                <div>
                  <h4>{{ t("main.h.leftDescription") }}</h4>
                  <p>{{ t("main.texts.leftText") }}</p>
                </div>
              </div>
              <div class="col-lg-6 image-1"></div>
            </div>
            <div class="row">
              <div class="col-lg-6 image-2"></div>
              <div class="col-lg-6 text">
                <div>
                  <h4>{{ t("main.h.rightDescription") }}</h4>
                  <p>{{ t("main.texts.rightText") }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="container bottom"></div>
        </div>
      </section>
      <section class="about-restaurant container-fluid">
        <div class="row">
          <div class="container-fluid b-d-left b-d-right top">
            <h3>{{ t("restaurant.h.bestRestaurant") }}</h3>
            <p>{{ t("restaurant.texts.description") }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 main">
            <div class="image-1 b-d-left">
              <img imgproxy-src="https://leonhotel.ru/rsz_dsc04103.jpg" class="object-cover" alt />
            </div>
            <div class="image-2">
              <img imgproxy-src="https://leonhotel.ru/rsz_dsc04095.jpg" class="object-cover" alt />
            </div>
            <div class="image-3 b-d-right">
              <img imgproxy-src="https://leonhotel.ru/rsz_dsc04028.jpg" class="object-cover" alt />
            </div>
            <div class="text-1 b-d-left">
              <div class="text b-d-bottom b-d-right">
                <h4>{{ t("restaurant.h.bestCuisine") }}</h4>
                <p>{{ t("restaurant.texts.cuisineDescription") }}</p>
                <a href="/restaurant">{{ t("common.more") }}</a>
              </div>
            </div>
            <div class="image-4">
              <img imgproxy-src="https://leonhotel.ru/rsz_1dsc04087.jpg" class="object-cover" alt />
            </div>
            <div class="text-2 b-d-right">
              <div class="text">
                <h4>{{ t("restaurant.h.delicious") }}</h4>
                <p>{{ t("restaurant.texts.chefDescription") }}</p>
                <a href="/restaurant">{{ t("common.more") }}</a>
              </div>
            </div>
            <div class="empty-1 b-d-bottom b-d-left"></div>
            <div class="empty-2 b-d-bottom b-d-right"></div>
          </div>
        </div>
        <div class="container bottom"></div>
      </section>
    </div>

    <section class="container-fluid parallax">
      <div class="parallax-title container-fluid">
        <div class="content">
          <div class="l-1 b-d-top"></div>
          <div class="l-2 b-d-top"></div>
          <h3>{{ t("about.h.paradise") }}</h3>
          <p>{{ t("about.texts.description") }}</p>
          <div class="show">
            <a href="/about">{{ t("common.more") }}</a>
          </div>
        </div>
      </div>
    </section>
    <LFooter />
    <LCreateOrder :show="showPopup" @close="closePopup"></LCreateOrder>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "main": {
      "h": {
        "mainDescription": "One of the Best Hotels",
        "leftDescription": "Comfortable",
        "rightDescription": "Affordable"
      },
      "texts": {
        "theBeast": "This beautiful place is located in the historic center of Sukhum. The perfect location makes it the best choice for both a single visit to the sunny city and a comfortable vacation, as our LEON hotel is located on the embankment just 2 minutes walk from the sea.",
        "leftText": "You can always book a room that has all the amenities for a comfortable stay. Bathrooms equipped with all accessories, mini-bars and safes are at your service in the rooms.",
        "rightText": "For an affordable price, you will immerse yourself in the historic center of Sukhum and you will have wonderful memories of this beautiful place with a rich history."
      }
    },
    "restaurant": {
      "h": {
        "bestRestaurant": "Best Restaurant in Abkhazia",
        "bestCuisine": "Best Cuisine",
        "delicious": "Very Delicious"
      },
      "texts": {
        "description": "The 'Leon' restaurant has long taken a leading place in the hearts of lovers of Pan-Asian and European cuisine. Original presentation of dishes, only fresh products, high level of service, cozy atmosphere and convenient location on Makhadzhirov embankment - this is what has made the restaurant popular, both in Abkhazia and beyond, for several years.",
        "cuisineDescription": "The restaurant's menu includes dishes from Japanese, Chinese, Italian and Abkhazian cuisines.",
        "chefDescription": "Two chefs work daily to ensure that your breakfasts, lunches and dinners are not just tasty, but also beautiful and healthy."
      }
    },
    "about": {
      "h": {
        "paradise": "Paradise Corner - Abkhazia"
      },
      "texts": {
        "description": "Abkhazia in the Abkhaz language sounds like Аҧсны, which translates into English as 'land of the soul'. There is a legend according to which God bequeathed these lands to himself, but gave them to the Abkhazians for their hospitality. Abkhazia is a country that beckons with its green palms, turquoise sea, emotional people, delicious food, wine, national dances. And that's not all."
      }
    },
    "common": {
      "more": "More"
    }
  },
  "ru": {
    "main": {
      "h": {
        "mainDescription": "Один из лучших отелей",
        "leftDescription": "Комфортно",
        "rightDescription": "Доступно"
      },
      "texts": {
        "theBeast": "Это прекрасное место находится в историческом центре Сухума. Идеальное расположение делает его лучшим выбором как для одиночного посещения солнечного города, так и для комфортного отдыха, так как наш отель LEON расположен на набережной всего в 2 минутах ходьбы от моря.",
        "leftText": "Вы можете всегда снять номер, в котором для комфортного проживания имеются все удобства. Ванные комнаты, оснащенные всеми принадлежностями, в номерах к вашим услугам мини-бары и сейфы.",
        "rightText": "За доступную цену вы окунетесь в исторический центр города Сухум и у Вас останутся прекрасные воспоминания об этом прекрасном месте с большой историей."
      }
    },
    "restaurant": {
      "h": {
        "bestRestaurant": "Лучший ресторан в Абхазии",
        "bestCuisine": "Лучшая кухня",
        "delicious": "Очень вкусно"
      },
      "texts": {
        "description": "Ресторан «Леон» давно занял лидирующее место в сердцах любителей паназиатской и европейской кухни. Оригинальная подача блюд, только свежие продукты, высокий уровень сервиса, уютная атмосфера и удачное расположение на набережной Махаджиров - это то, благодаря чему, на протяжении нескольких лет, ресторан популярен, как в самой Абхазии, так и за её пределами.",
        "cuisineDescription": "В меню ресторана включены блюда японской, китайской, итальянской и абхазской кухонь.",
        "chefDescription": "Два шеф-повара ежедневно работают над тем, чтобы ваши завтраки, обеды и ужины были не просто вкусными, но ещё красивыми и полезными."
      }
    },
    "about": {
      "h": {
        "paradise": "Райский уголок - Абхазия"
      },
      "texts": {
        "description": "Абхазия на абхазском языке звучит, как Аҧсны, что переводится на русский, как «страна души». Есть предание, по которому Бог завещал себе эти земли, но отдал их абхазам за их гостеприимство. Абхазия - это страна, манящая своими зелёными пальмами, бирюзовым морем, эмоциональными людьми, вкуснейшей едой, вином, национальными танцами. И это далеко не всё."
      }
    },
    "common": {
      "more": "Подробнее"
    }
  }
}
</i18n>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

const { locale, t } = useI18n()

// State
const newDate = ref('')
const tomorrowDate = ref('')
const showPopup = ref(false)
const success = ref(false)

// Methods
const orderRoom = () => {
  showPopup.value = true
}

const closePopup = () => {
  showPopup.value = false
}

const getWeekDay = (date) => {
  const daysRu = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]
  const daysEn = ["Sun", "Mun", "Tiu", "Wenz", "Thurz", "Frai", "Sa"]
  return locale.value === "ru" ? daysRu[date.getDay()] : daysEn[date.getDay()]
}

const getDay = (date) => {
  return date.getDate()
}

const getMounth = (date) => {
  return date.toLocaleString(locale.value, { month: "short" })
}

// Lifecycle
onMounted(() => {
  // Set current date
  const today = new Date()
  newDate.value = `${getWeekDay(today)}., ${getDay(today)} ${getMounth(today)}`

  // Set tomorrow date
  const tomorrow = new Date()
  const dateTomorrow = new Date(tomorrow.setDate(tomorrow.getDate() + 1))
  tomorrowDate.value = `${getWeekDay(dateTomorrow)}., ${getDay(dateTomorrow)} ${getMounth(dateTomorrow)}`
})

// SEO optimization
useHead({
  title: 'LEON BOUTIQUE HOTEL - Бутик-отель в Сухуме, Абхазия',
  meta: [
    {
      name: 'description',
      content: 'LEON BOUTIQUE HOTEL - один из лучших отелей в Абхазии, расположенный в историческом центре Сухума на набережной в 2 минутах от моря. Комфортные номера и первоклассный ресторан.'
    },
    {
      name: 'keywords',
      content: 'отель в абхазии, отель в сухуме, гостиница, бутик-отель, леон, проживание, номера, бронирование'
    },
    {
      property: 'og:title',
      content: 'LEON BOUTIQUE HOTEL - Бутик-отель в Сухуме, Абхазия'
    },
    {
      property: 'og:description', 
      content: 'LEON BOUTIQUE HOTEL - один из лучших отелей в Абхазии, расположенный в историческом центре Сухума на набережной в 2 минутах от моря. Комфортные номера и первоклассный ресторан.'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:image',
      content: '/img/hotel-main.jpg'
    },
    {
      property: 'og:url',
      content: 'https://leonhotel.ru/'
    }
  ]
})

definePageMeta({
  layout: 'default'
})
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.back section.container-fluid {
  z-index: 4;
}

.row_info {
  height: 50px;
  width: 1062px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.input_block,
.button_block {
  color: white;
  padding-right: 28px;
  display: block;
}

.button_block {
  padding-right: 0;
}

.fio_input,
.arrival_date,
.departure_date {
  width: 195px;
  height: 50px;
  border: 2px solid #d9ccaf;
  background: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  filter: brightness(0.9);
}

.fio_input {
  width: 356px;
}

.fio_input::placeholder,
.arrival_date::placeholder,
.departure_date::placeholder {
  font-family: "Lato";
  font-size: 16px;
  padding-left: 17px;
  color: white;
}

.arrival_date::placeholder,
.departure_date::placeholder {
  padding: 0;
  text-align: center;
}

.fast-order {
  max-width: 1170px;
  height: 126px;
  padding: 0;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: -120px;
}

.fast-order input.fio,
.fast-order .date {
  width: 340px;
  height: 55px;
  margin-left: 65px;
  border: 1px solid #707070 !important;
  padding-left: 11px;
  font-family: "Lato";
  font-size: 20px;
  color: #000;
}

@media only screen and (max-width: $xl) {
  .row_info {
    width: 100%;
  }

  .fast-order input.fio_input,
  .fast-order .arrival_date .departure_date {
    width: 320px;
    font-size: 16px;
  }
}

.fast-order input.fio_input:hover,
.fast-order input.fio_input:focus,
.fast-order .arrival_date:hover,
.fast-order .arrival_date:focus,
.fast-order .departure_date:hover,
.fast-order .departure_date:focus {
  outline: none !important;
}

.fast-order button.submit {
  width: 211px;
  height: 49px;
  background: var(--unnamed-color-d9ccaf) 0% 0% no-repeat padding-box;
  background: #d9ccaf 0% 0% no-repeat padding-box;
  color: black !important;
  font-family: "Lato" !important;
  font-size: 16px !important;
}

.about-hotel {
  width: 1350px;
  padding-top: 30px;
  margin-top: 100px;
}

.about-hotel .main {
  background: url("/img/sprite_circles.svg") repeat;
  min-height: 400px;
}

.about-hotel .top,
.about-hotel .bottom {
  max-width: 1170px;
}

.about-hotel .top {
  border-left: 2px solid #d9ccaf;
  border-right: 2px solid #d9ccaf;
  border-top: 2px solid #d9ccaf;
  padding-left: 111px;
  padding-right: 111px;
  margin-bottom: 30px;
}

.about-hotel .top h3 {
  margin-left: auto;
  margin-right: auto;
  margin-top: -21px;
  font-family: "fairplay";
  font-size: 32px;
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 2px;
  line-height: 1;
}

.about-hotel .top p {
  font-family: "Lato";

  font-size: 18px;
  text-align: center;
  line-height: 26px;
  margin-bottom: -5px;
  padding-bottom: 0px;
}

.about-hotel .main .image-1 {
  background: url("/rsz_1arm_9615.jpg");
}

.about-hotel .main .image-2 {
  background: url("/IMG_7031.jpg");
}

.about-hotel .main .image-1,
.about-hotel .main .image-2 {
  background-position: center;
  background-size: cover;
  height: 675px;
}

.about-hotel .main .text {
  height: 675px;
  display: flex;
}

.about-hotel .main .text div {
  margin: auto;
  background-color: white;
  max-width: 496px;
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 66px;
  padding-right: 66px;
}

.about-hotel .main .text div h4 {
  font-family: "playfair";
  font-size: 24px;
  line-height: 32px;
  margin-top: 0;
  margin-bottom: 1rem;
}

.about-hotel .main .text div p {
  font-family: "Lato";
  margin-top: 0;
  font-size: 18px;
  text-align: left;
  margin-bottom: 0px;
  padding-bottom: 0px;
  margin-bottom: 1rem;
  line-height: 28px;
}

.about-hotel .bottom {
  margin-top: 22px;
  height: 30px;
  border-left: 2px solid #d9ccaf;
  border-right: 2px solid #d9ccaf;
  border-bottom: 2px solid #d9ccaf;
  margin-bottom: 100px;
}

.about-restaurant {
  width: 1410px;
  border-top: 2px solid #d9ccaf;
}

.about-restaurant .top {
  padding-left: 111px;
  padding-right: 111px;
  margin-bottom: 0;
  padding-bottom: 30px;
}

.about-restaurant .top h3 {
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  margin-top: -25px;
  font-family: "playfair";
  font-size: 32px;
  margin-bottom: 16px !important;
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  width: 520px;
}

.about-restaurant .top p {
  font-family: "Lato";
  font-size: 18px;
  text-align: center;
  line-height: 26px;
  margin-bottom: -5px;
  padding-bottom: 0px;
  width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.about-restaurant .main {
  padding-left: 0px;
  padding-right: 0px;
  display: block;
  height: 812px;
  margin-bottom: 140px;
}

/* ////////////////////////////// */
.b-d-left {
  border-left: 2px solid #d9ccaf !important;
}

.b-d-right {
  border-right: 2px solid #d9ccaf !important;
}

.b-d-bottom {
  border-bottom: 2px solid #d9ccaf !important;
}

.b-d-top {
  border-top: 2px solid #d9ccaf !important;
}

.about-restaurant .main .text {
  margin-top: 0px;
  width: 100%;
  padding-bottom: 50px;
}

.about-restaurant .main .text h4 {
  font-family: "playfair";
  font-size: 28px !important;
  line-height: 37px !important;
  margin-top: -8px;
}

.about-restaurant .main .text p {
  font-family: "Lato";
  font-size: 16px !important;
  text-align: left;
  line-height: 24px !important;
  padding-bottom: 15px;
}

.about-restaurant .main .text a {
  font-family: "Lato";
  font-size: 16px;
  text-align: left;
  color: #272525;
  text-decoration: none !important;
  position: absolute;
  bottom: 15px;
  right: 40px;
  border-bottom: 1px solid #d9ccaf;
  line-height: 19px !important;
}

.about-restaurant .main .text-2 a {
  right: 70px;
}

.about-restaurant .image-1 img,
.about-restaurant .image-2 img,
.about-restaurant .image-3 img,
.about-restaurant .image-4 img {
  height: 100%;
  width: 100%;
  position: relative;
}

.input_block {
  display: none;
}

@media (min-width: $sm) {}

@media (min-width: $md) {}

@media (min-width: $lg) {
  button.submit {
    width: 230px;
    margin-top: 25px !important;
    color: black !important;
    margin-left: 0 !important;
    font-family: "Lato" !important;
    font-size: 16px !important;
  }

  div.back {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
  }

  .input_block {
    display: block;
  }

  .about-restaurant {
    position: relative;
    margin-left: -15px;
    margin-right: -15px;
    float: left;
    width: 1378px;
  }

  .about-restaurant .image-1,
  .about-restaurant .image-2,
  .about-restaurant .image-3,
  .about-restaurant .image-4,
  .about-restaurant .text-1,
  .about-restaurant .text-2,
  .about-restaurant .empty-1,
  .about-restaurant .empty-2 {
    position: absolute;
  }

  .about-restaurant .image-1 {
    left: 0;
    right: 50%;
    top: 0;
    height: 305px;
    padding: 5px;
    padding-left: 25px;
  }

  .about-restaurant .image-2 {
    left: 50%;
    right: 75%;
    top: 0;
    padding: 5px;
    height: 610px;
    width: 351.5px;
  }

  .about-restaurant .image-3 {
    left: 75%;
    right: 0;
    top: 0;
    height: 405px;
    padding: 5px;
    padding-right: 25px;
  }

  .about-restaurant .image-4 {
    left: calc(25% + 12.5px);
    right: 50%;
    top: 305px;
    padding: 5px;
    height: 512px;
  }

  .about-restaurant .text-1 {
    left: 0;
    right: 25%;
    top: 305px;
    padding: 0px;
    width: 340px;
  }

  .about-restaurant .text-2 {
    right: 0px;
    top: 405px;
    padding: 0px;
    width: 321.5px;
  }

  .about-restaurant .main .text-1 .text {
    padding-left: 40px;
    padding-right: 35px;
    padding-top: 32px;
  }

  .about-restaurant .main .text-2 .text {
    margin-top: 32px;
    padding-left: 0px;
    padding-right: 60px;
    margin-left: 28px;
  }

  .empty-1 {
    left: calc(50% + 35px);
    height: 64px;
    right: 25%;
    top: 611px;
    z-index: -1;
  }

  .empty-2 {
    left: 75%;
    height: 364px;
    right: 0;
    top: 311px;
    z-index: -1;
  }
}

.parallax {
  padding: 0;
  height: 568px;
  position: relative;
  overflow: hidden;

  background-position: center;
  background-size: auto;
  background-image: url("/img/parallax.jpg");
}

.parallax:after {
  content: "";
  position: absolute;
  backdrop-filter: brightness(80%);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(87, 71, 36, 0.25);
  z-index: 2;
}

.parallax-title {
  position: absolute;
  top: calc(50% - 140px);
  padding: 20px;
  color: white;
  text-align: center;
  height: 280px;
  z-index: 100;
}

.parallax-title div.content {
  width: 856px;
  margin-left: auto;
  margin-right: auto;
  border-left: 2px solid #d9ccaf;
  border-right: 2px solid #d9ccaf;
  border-bottom: 2px solid #d9ccaf;
  height: 100%;
  position: relative;
  display: flex;
  padding: 40px;
}

.parallax-title div h3 {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  top: -21px;
  left: 186.75px;
  right: 186.75px;
  margin: 0;
  font-family: "Didot";

  font-size: 28px !important;
  padding-left: 00px;
  padding-right: 00px;
  margin-bottom: 0;
}

.parallax-title div p {
  font-family: "Lato";
  color: white;
  font-size: 18px;
  text-align: center;
  line-height: 27px;
  margin-bottom: -5px;
  margin: auto;
}

.parallax-title div.content .l-1,
.parallax-title div.content .l-2 {
  position: absolute;
}

.parallax-title div.content .l-1 {
  left: 0;
  top: 0;
  width: 250px;
}

.parallax-title div.content .l-2 {
  right: 0;
  top: 0;
  width: 250px;
}

.show {
  position: absolute;
  right: 60px;
  bottom: 13.5px;
}

.show a {
  text-decoration: none;
  border-bottom: 1px solid white;
  font-size: 16px !important;
  font-weight: 400;
  font-family: "Segoe UI";
  letter-spacing: 0px;
  color: #ffffff !important;
}

@media (max-width: 768px) {
  .show {
    left: 0;
    right: 0;
    bottom: 12.5px;
  }
}
</style>

<style>
html {
  scroll-behavior: smooth !important;
}

h3,
h4 {
  font-weight: 400 !important;
  font-style: normal !important;
}

p {
  font-weight: 400 !important;
  font-style: normal !important;
}
</style>

<style lang="scss" scoped>
@media (min-width: 1600px) {
  .parallax {
    padding: 0;
    height: 568px;
    position: relative;
    overflow: hidden;
    background-position: center;
    background-size: 100%;
    background-image: url("/img/parallax.jpg");
  }
}

@media (max-width: 1599px) {
  .parallax {
    padding: 0;
    height: 568px;
    position: relative;
    overflow: hidden;
    background-position: center;
    background-size: auto;
    background-image: url("/img/parallax.jpg");
  }
}

@media (max-width: 1200px) {
  .top h3 {
    max-width: calc(100% - 4px) !important;
    overflow: hidden;
    text-align: center;
  }

  .fast-order {
    display: none !important;
    // height: 115px;
    // margin-top: -115px;
    // background-color: transparent;
    // box-shadow: none;
    // padding: 0;
    // display: block;
  }

  .fast-order input {
    display: none !important;
  }

  .down {
    position: absolute;
    // bottom: calc(50px - 8.72px);
    left: calc(50% - 37.175px);
    top: 85px;
  }

  .button_block {
    position: absolute;
    bottom: 61px;
    left: 0;
    right: 0;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    // z-index:2;
    // button.submit {

    //   // background-color: transparent;
    //   // border: 2px solid #d9ccaf !important;
    //   // color: white;
    //   // font-family: "Lato";
    //   // font-size: 16px;
    // }
  }

  .about-hotel {
    width: 100%;
    margin-top: 20px;
  }

  .about-hotel .top {
    width: calc(100% - 32px);
    padding-left: 32px;
    padding-right: 32px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .about-hotel .top h3 {
    font-size: 24px;
    margin-top: -15px;
    text-align: center;
  }

  .about-hotel .top p {
    font-size: 16px;
  }

  .about-hotel .main .row:last-child {
    display: none;
  }

  .about-hotel .main .text {
    display: none;
  }

  .about-hotel .bottom {
    width: calc(100% - 32px);
    margin-bottom: 0px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .about-restaurant {
    width: 100%;
    margin-top: 20px;
    border: none !important;
  }

  .about-restaurant .top {
    width: calc(100% - 32px);
    padding: 0px;
    border: none !important;
    border-top: 2px solid #d9ccaf !important;
    border-left: 2px solid #d9ccaf !important;
    border-right: 2px solid #d9ccaf !important;
    margin-bottom: 30px;
    margin-top: 30px;
  }

  .about-restaurant .top h3 {
    font-size: 24px;
    margin-top: -21px;
    width: 344px;
    text-align: center;
  }

  .about-restaurant .top p {
    font-size: 16px;
    border: none;
    width: 100%;
  }

  .about-restaurant .main {
    height: auto;
    margin-bottom: 0;
  }

  .about-restaurant .image-1,
  .about-restaurant .image-3,
  .about-restaurant .image-4,
  .about-restaurant .text-1,
  .about-restaurant .text-2,
  .about-restaurant .empty-1,
  .about-restaurant .empty-2 {
    display: none;
  }

  .about-restaurant .bottom {
    margin-top: 22px;
    height: 30px;
    border-left: 2px solid #d9ccaf;
    border-right: 2px solid #d9ccaf;
    border-bottom: 2px solid #d9ccaf;
    margin-bottom: 0px;
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .about-restaurant {
    margin-bottom: 50px;
  }

  div.back {
    float: left;
  }

  .parallax {
    height: 620px;
    background-size: auto;
  }

  .v-parallax {
    height: 620px !important;
  }

  .v-parallax__content .align-center {
    margin: auto;
    display: flex;
    height: 100%;
    width: 100%;
  }

  .parallax-title div.content {
    width: 100%;
    height: auto;
    margin: auto;
  }

  .parallax-title {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    margin: auto;
    display: flex;
  }

  .parallax-title div.content h3 {
    font-size: 24px !important;
    text-align: center;
    top: -23px;
    left: calc(50% - 155px);
    right: auto;
    width: 310px;
    background-color: transparent;
  }

  .parallax-title div.content .l-1 {
    width: auto;
    right: calc(50% + 155px);
  }

  .parallax-title div.content .l-2 {
    width: auto;
    left: calc(50% + 155px);
  }

  .parallax-title p {
    font-size: 16px;
    border: none;
    width: 100%;
  }
}

.heading_style {
  font-size: 32px;
  font-family: "playfair" !important;
  letter-spacing: 0px;
  color: #272525;
}

.description_style {
  margin-top: 30px;
  font-size: 18px;
  font-family: "Lato" !important;
  letter-spacing: 0px;
  color: #272525;
  margin-left: 140px;
  margin-right: 140px;
}

@media (max-width: 700px) {
  .about-hotel .top {
    margin-bottom: 20px;
  }

  .about-hotel .bottom {
    margin-top: 10px;
    height: 20px;
  }

  .description_style {
    margin-left: 0;
    margin-right: 0;
    margin-top: 10px;
  }

  .about-hotel .top h3 {
    font-size: 20px;
  }

  .about-hotel .top p {
    font-size: 16px;
  }

  .about-restaurant .top h3 {
    font-size: 20px;
    width: 300px;
    padding: 0;
    margin-bottom: 5px !important;
  }

  .about-restaurant .top p {
    font-size: 16px;
    padding: 0 15px;
    margin-top: 0px;
  }

  .about-restaurant .top {
    margin-bottom: 20px;
  }

  .about-restaurant .bottom {
    margin-top: 10px;
    height: 20px;
  }
}

@media (max-width: 376px) {
  .parallax-title div.content h3 {
    font-size: 24px !important;
  }

  .parallax-title p {
    font-size: 16px !important;
    border: none;
    width: 100%;
  }

  .parallax-title div.content .l-1 {
    width: auto;
    right: calc(50% + 145px);
  }

  .parallax-title div.content .l-2 {
    width: auto;
    left: calc(50% + 145px);
  }
}
</style>

<style>
html {
  scroll-behavior: smooth !important;
}
</style>
